import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
// import reportWebVitals from '../react/Apps/reportWebVitals';
import { Provider } from 'react-redux';

import DocToLib from '../react/Apps/DocToLib/DocToLib';
import { store } from '../react/Apps/DocToLib/store/store';

document.addEventListener('DOMContentLoaded', () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  const railsData = JSON.parse(document.getElementById('railsdata').getAttribute('data'));
  root.render(
    <Provider store={store}>
      <DocToLib railsData={railsData} />
    </Provider>
  )
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
